<template>
    <div id="form-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">

            <div class="container">
                <h2 class="form-title" v-if="moduleData.Title && moduleData.ShowTitle">{{ moduleData.Title }}</h2>
                <div class="form-content" v-if="moduleData.Content" v-html="moduleData.Content"></div>
                <div class="form-response" v-if="getFormModuleResponses">
                    <div class="message" v-html="getFormModuleResponses"></div>
                </div>
                <form v-else-if="moduleData.Fields.length" @submit.prevent="submitForm">
                    <template v-for="(field, index) in moduleData.Fields">
                        <div class="field" v-if="field.FieldClass === 'EditableCheckboxGroupField'" :class="field.ExtraClass">
                            <label v-if="field.Title">{{ field.Title }}</label>
                            <div v-for="(option, index) in field.Options" :key="index">
                                <input type="checkbox" :id="option.Name" :name="field.Name + '[' + option.Value + ']'"
                                       :checked="option.CheckedDefault === 1 ? true : false"
                                       :required="option.Required === 1 ? true : false">
                                <label v-if="option.Title" :for="option.Name">{{ option.Title }}</label>
                            </div>
                        </div>
                        <div class="field" v-if="field.FieldClass === 'EditableDropdown'" :class="field.ExtraClass">
                            <label v-if="field.Title" :for="field.Name">{{ field.Title }}</label>
                            <!--                            <select class="plain-select" :id="field.Name" :name="field.Name">-->
                            <!--                                <option v-for="(option, index) in field.Options" :key="index" :value="option.Value" :selected="option.Default === 1 ? true : false">-->
                            <!--                                    {{option.Title}}-->
                            <!--                                </option>-->
                            <!--                            </select>-->
                            <v-select :id="field.Name"
                                      :name="field.Name"
                                      label="Title"
                                      :searchable="false"
                                      :reduce="o => o.Value"
                                      :options="field.Options"
                                      :clearable="field.Required === 1 ? false : true"
                                      :placeholder="field.EmptyString"
                                      v-model="userFormSelectData[index]">
                            </v-select>
                        </div>
                        <div class="field" v-if="field.FieldClass === 'EditableEmailField'" :class="field.ExtraClass">
                            <label v-if="field.Title" :for="field.Name">{{ field.Title }}</label>
                            <input type="email" :id="field.Name" :name="field.Name" :placeholder="field.Placeholder"
                                   :required="field.Required === 1 ? true : false">
                        </div>
                        <div class="field user-content" v-if="field.FieldClass === 'EditableLiteralField'" :class="field.ExtraClass">
                            <div v-html="field.Content"></div>
                        </div>
                        <div class="field user-content" v-if="field.FieldClass === 'EditableFormHeading'" :class="field.ExtraClass">
                            <h3>{{ field.Title }}</h3>
                        </div>
                        <div class="field" v-if="field.FieldClass === 'EditableNumericField'" :class="field.ExtraClass">
                            <label v-if="field.Title" :for="field.Name">{{ field.Title }}</label>
                            <input type="number" :id="field.Name" :name="field.Name" :placeholder="field.Placeholder"
                                   :required="field.Required === 1 ? true : false">
                        </div>
                        <div class="field" v-if="field.FieldClass === 'EditableRadioField'" :class="field.ExtraClass">
                            <label v-if="field.Title">{{ field.Title }}</label>
                            <div v-for="(option, index) in field.Options" :key="index">
                                <input type="radio" :id="option.Name" :name="field.Name" :checked="option.Default === 1 ? true : false"
                                       :required="field.Required === 1 ? true : false" :value="option.Value">
                                <label v-if="option.Title" :for="option.Name">{{ option.Title }}</label>
                            </div>
                        </div>
                        <div class="field" v-if="field.FieldClass === 'EditableTextField'" :class="field.ExtraClass">
                            <label v-if="field.Title" :for="field.Name">{{ field.Title }}</label>
                            <input v-if="field.Rows === 1" type="text" :id="field.Name" :name="field.Name" :placeholder="field.Placeholder"
                                   :required="field.Required === 1 ? true : false">
                            <textarea v-else :id="field.Name" :name="field.Name" :placeholder="field.Placeholder" :rows="field.Rows"
                                      :required="field.Required === 1 ? true : false"></textarea>
                        </div>
                    </template>
                    <div class="full-width"></div>
                    <div class="field half-width actions">
                        <vue-recaptcha class="recaptcha" :sitekey="siteKey" :loadRecaptchaScript="true"
                                       @verify="validateRecaptcha"></vue-recaptcha>
                    </div>
                    <div class="field half-width actions">
                        <input type="submit" class="btn btn-dark" :disabled="!verified" :value="moduleData.SubmitButtonText">
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: "ElementForm",
    props: {
        component: {
            type: Object,
        }
    },
    components: {VueRecaptcha},
    data() {
        return {
            userFormSelectData: [],
            siteKey: '6LdJpeQZAAAAAAIcHZ_5FWf5EkRVzie01Ce2GyDu',
            verified: false
        }
    },
    computed: {
        ...mapGetters(['getModuleData', 'getSettings', 'getFormModuleResponses']),
        moduleData() {
            return this.getModuleData(this.component.ID);
        }
    },
    watch: {
        getFormModuleResponses: function (val) {
            if (val && val !== '') {
                $(this.$el)[0].scrollIntoView({behavior: 'smooth'});
            }
        }
    },
    methods: {
        ...mapActions(['submitUserForm']),
        submitForm(e) {
            let form = e.target,
                data = new FormData(form);

            this.userFormSelectData.forEach((value, index) => {
                let field = this.moduleData.Fields[index];
                if (field) {
                    data.append(field.Name, value);
                }
            });

            data.append('FormID', this.moduleData.ID);

            this.submitUserForm(data);
        },
        validateRecaptcha(response) {
            if (response) {
                this.verified = true;
            }
        }
    }
}
</script>
